import { useContext } from "react";
import { DriverAuthContext } from "@/context/DriverAuthContext";
import type { DriverAuthContextValue } from "@/context/DriverAuthContext";

/**
 * Access the driver auth context.
 *
 * Must be used inside `<DriverAuthProvider>`.
 */
export function useDriverAuth(): DriverAuthContextValue {
  const ctx = useContext(DriverAuthContext);
  if (!ctx) {
    throw new Error("useDriverAuth must be used within a <DriverAuthProvider>");
  }
  return ctx;
}
